/**
 * Converte a URL de um arquivo remoto para o proxy same-origin `/file-proxy/<host>/<path>`.
 * O proxy (Next rewrites, Vite dev ou nginx) só aceita os hosts de file-proxy.config.mjs.
 * blob:, data:, caminhos relativos e URLs da própria origem passam direto.
 */
export function toFilePreviewUrl(url: string): string {
  if (/^(blob|data):/i.test(url)) return url;
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return url;
  }
  if (typeof window !== "undefined" && parsed.origin === window.location.origin) return url;
  return `/file-proxy/${parsed.host}${parsed.pathname}${parsed.search}`;
}
